var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-8" }, [
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Message:")]),
      _vm._v(" "),
      _c("div", { staticClass: "message-content" }, [
        _vm._v(_vm._s(_vm.content)),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-4" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }